import moment from 'moment';
import UploadFileVisiteMA from '@/views/mdt/societe/societeDetails/historique-visites-medicales/recap-visites-medicales/upload-file-visites-medicales'
import ModalViewResult from '@/views/mdt/societe/societeDetails/historique-visites-medicales/recap-visites-medicales/modal-view-result'
export default {
  name: 'recap-visites-medicales',
  components: {UploadFileVisiteMA,ModalViewResult},
  props: ["visite"],
  data () {
    return {
      filters: [],
      loading_data: true,
      selectedElement: null,
      element_type: null,
      element_id:null,
      element: null,
      programmation: null,
      viewProgrammation: null,
      fields: [
        {key:'index', label:'N°'},
        {key:'patient',label: 'Patient'},
        {key: 'age',label:"Age"},
        {key: 'sexe',label: "Sexe" },
        {key: 'departement',label: "Département" },
        {key: 'poste',label: "Poste" },
        {key: 'is_done',label: "Statut" },
        {key: "actions",label:"Actions"}
      ]

    }
  },
  watch: {
    results() {
      this.results.forEach(()=> {
        let single_filter = {word: ""}
        this.filters.push(single_filter)
      });

    },
    selectedElement(){
      if(this.selectedElement ===null){
        this.element_type = null,
        this.element_id = null
      } else {
        this.element_type = this.selectedElement.type,
        this.element_id = this.selectedElement.id
      }
      
    }

  },
  computed: {
    results(){
      return this.$store.getters["visiteMedicaleResults"]
    }, 
    stats(){
      return this.$store.getters["visiteDoneStats"]
    },
    year(){
      return moment(this.visite.d_dbut).year()
    }
  },
  mounted () {
    // this.$store.dispatch("getSocieteVisiteMedicaleStatsDone",this.visite.id).then(
    //   ()=>{
    //     this.loading_data = false
    //   }
    // )

    this.$store.dispatch("getVisiteMedicaleResults",this.visite.id).then(
      () => {
        this.loading_data = false
      }
    )


  },
  methods: {
    backToList(){
      this.$emit("onClickBackToList",null)
    },
    selectRow(result,programmation){
      this.element = result,
      this.programmation = programmation
    },
    selectProgrammationToView(programmation){
      this.viewProgrammation = programmation
    }

  }
}


